import React, { useState, useMemo, useEffect } from "react";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { DropdownTopbarItemToggler } from "../../../../_metronic/_partials/dropdowns";
// '../../../_metronic/_partials/dropdowns';
import clsx from "clsx";
import { useHistory } from "react-router-dom";
import { EncryptStorage } from "encrypt-storage";

export const encryptStorage = EncryptStorage("secret_key", {
  prefix: "@prefix",
});

var Role;

export function RetRole() {
  return Role;
}

export function RoleDropdown(props) {
  const roles = [
    "Convidado",
    "Colaborador",
    "Especialista",
    "Responsavel ferramenta",
    "Membro et",
    "Gestor",
    "Admin fabrica",
    "Admin corporativo",
    "Superadmin",
  ];
  const [selectRole, setSelectRole] = useState("");

  let history = useHistory();

  useEffect(() => {
    setSelectRole(encryptStorage.getItem("SystemRole").name);
    Role = encryptStorage.getItem("SystemRole").name;
    // console.log(JSON.parse(localStorage['SystemRole']).Name)
    //console.log('RoleDropdown')
  }, []);

  function changeRole(role) {
    setSelectRole(role);
    encryptStorage.setItem("SystemRole", JSON.stringify({ name: role }));
    Role = role;
    history.push("/");
  }

  return (
    <>
      <Dropdown drop="down" alignRight onClick={(e) => e.stopPropagation()}>
        <Dropdown.Toggle as={DropdownTopbarItemToggler}>
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip id="language-panel-tooltip">Nível de permissão</Tooltip>
            }
          >
            <div
              className={
                "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
              }
            >
              <span className="text-dark-50 font-weight-bolder font-size-base mr-3">
                {selectRole}
              </span>
            </div>
          </OverlayTrigger>
        </Dropdown.Toggle>

        <Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg">
          <ul className="navi navi-hover py-4">
            <div className="listFab">
              {roles.map((role, i) => (
                <li key={i} className={clsx("navi-item")}>
                  <a
                    href="#"
                    onClick={() => changeRole(role)}
                    className="navi-link"
                  >
                    <span className="navi-text">{role}</span>
                  </a>
                </li>
              ))}
            </div>
          </ul>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}
